import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AvailabilityRulesReducers } from 'src/app/store/app.reducers';

const getAvailabilityRulesState = createFeatureSelector<AvailabilityRulesReducers.AvailabilityRulesState>(AvailabilityRulesReducers.TAG);

export const getAvailabilityRulesData = createSelector(getAvailabilityRulesState, (state) => state?.data);
